import orderFoodIcon from '../../assets/order-food-icon.png';
import bookYourBuffetIcon from '../../assets/book-your-buffet-icon.png';
import chooseYourMenuIcon from '../../assets/choose-your-menu-icon.png';
import { getDeviceType } from '../../utils/common';

const deviceType = getDeviceType();

export const buttons = [
    {
        buttonTitle: 'Click to Order from Our Daily Menu',
        link: '/order-food',
        buttonClass: 'order-button order-now-btn',
        containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
        linkClass: 'order-now-btn-link',
        icon: orderFoodIcon,
    },
    {
        buttonTitle: 'Click to Order As Per Your Choice',
        link: '/choose-your-menu',
        buttonClass: 'order-button order-now-btn',
        containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
        linkClass: 'order-now-btn-link',
        icon: chooseYourMenuIcon,
        disabled: (() => {
            const now = new Date();
            const hour = now.getHours();
            return hour < 10 || hour >= 19;
        })(),
    },
    {
        buttonTitle: 'Click to Book Your Buffet',
        link: '/book-your-buffet',
        buttonClass: 'order-button order-now-btn',
        containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
        linkClass: 'order-now-btn-link',
        icon: bookYourBuffetIcon,
    }
]